import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { BtnActionEnum } from '../../enums/btn-action.enum';
import { BtnActionService } from '../../services/btn-action.service';
import { BtnActionInterface } from '../../interfaces/btnAction.interface';

@Component({
    selector: 'app-btn-action',
    templateUrl: './btn-action.component.html',
    styleUrls: ['./btn-action.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BtnActionComponent implements OnInit {

  @Input() typdeBtnAction: BtnActionEnum;
  @Input() iconCustom: string;
  @Input() textCustom: string;
  @Input() btnDisabled = false;
  @Input() activeBtnSearch = true;
  @Input() viewType: 'list' | 'grid';
  btnActionEnum  = BtnActionEnum;
  btnActionInterface: BtnActionInterface;
  click = false;
  @Output() btnClickEventEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private btnService: BtnActionService,
  ) { }

  ngOnInit(): void {
    if (this.typdeBtnAction != BtnActionEnum.CUSTOM) {
      this.btnActionInterface = this.btnService.getIconTextBtn(this.typdeBtnAction);
    } else {
      this.btnActionInterface = this.btnService.getIconTextBtnCustom(this.textCustom, this.iconCustom);
    }
  }

  onActionFilter($event) {
    // afficher le bouton cliqué 2s

    this.click = !this.click;
    this.activeBtnSearch = !this.activeBtnSearch;
    if ($event.target.id === 'idBtnAction') {
      this.toggleStyleBtn(this.click, $event);
    } else if ($event.target.id === 'idBtnActionCustom') {
      this.toggleStyleBtnCustom(this.click, $event);
    }

    this.btnClickEventEmitter.emit(true);
  }

  toggleStyleBtn(valClick: boolean, event) {
    switch (this.typdeBtnAction) {
      case BtnActionEnum.GROUP :
        if (valClick) {
          event.target.classList.remove('btn-action-page');
          event.target.classList.add('btn-action-page-clicked');
        } else {
          event.target.classList.remove('btn-action-page-clicked');
          event.target.classList.add('btn-action-page');
        }
      break;
      case BtnActionEnum.SEARCH :
        if (this.activeBtnSearch) {
          event.target.classList.remove('btn-action-page');
          event.target.classList.add('btn-action-page-clicked-export');
        } else {
          event.target.classList.remove('btn-action-page-clicked-export');
          event.target.classList.add('btn-action-page');
        }
      break;
      case BtnActionEnum.TRIE :
        if (valClick) {
          event.target.classList.remove('btn-action-page');
          event.target.classList.add('btn-action-page-clicked');
        } else {
          event.target.classList.remove('btn-action-page-clicked');
          event.target.classList.add('btn-action-page');
        }
      break;
      default :
        event.target.classList.remove('btn-action-page');
        event.target.classList.add('btn-action-page-clicked');
        setTimeout(() => {
          event.target.classList.remove('btn-action-page-clicked');
          event.target.classList.add('btn-action-page');
        }, 1600);

      break;
    }
  }

  toggleStyleBtnCustom(valClick: boolean, event) {
    event.target.classList.remove('btn-action-page');
        event.target.classList.add('btn-action-page-clicked');
        setTimeout(() => {
          event.target.classList.remove('btn-action-page-clicked');
          event.target.classList.add('btn-action-page');
        }, 1600);
  }
}
